import React, { useEffect, useState } from "react";
import "../Css/Membership.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaCheck } from "react-icons/fa";

const MemberShip = () => {
  // State to store membership plans and selected card index
  const [plans, setPlans] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  // Fetch membership plans from the API
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/auth/Plans/active`)
      .then((response) => {
        setPlans(response.data); // Assuming response data contains an array of plans
      })
      .catch((error) => {
        console.error("Error fetching membership plans:", error);
      });
  }, []);

  // Handler to set active card index and reset others
  const handleCardClick = (index) => {
    setActiveIndex(index); // Set the selected card as active
  };

  return (
    <React.Fragment>
      <div className="mainDivMeberShip">
        <Container>
          <div className="membershipTitle">Join the Exclusive Platinum Club</div>
          <div className="memberDescriptionDiv">
            <div className="membershipDescriptionPera">
              Leverage our exclusive network and expertise. Complete our form
              and a matchmaking specialist will contact you to curate a
              personalized package. No obligation and your privacy is assured.
              Begin your extraordinary journey!
            </div>
          </div>
             <div className="contacuUsLlinkDiv">
                      <Link className="contacusLink" to="/membership-form">
                        Become a platinum Member
                      </Link>
                    </div>
          {/* <Row className="membershipRow">
            {plans.map((plan, index) => (
              <Col lg={6} md={6} key={index}>
                <Card
                  className="memberShipCard"
                  onClick={() => handleCardClick(index)}
                  style={{
                    backgroundColor: activeIndex === index ? "#fff" : "transparent",
                  }}
                >
                  <div className="platinumDiv">
                    <div className="platinumSercalTitle">
                      <div className="platinumSercalTitle">
                        <div className="checkIconDiv"  >

                      <FaCheck
                        className="platinumIcon"
                        style={{ color: activeIndex === index ? "#fff" : "#9EA4B2" }}
                        />
                        </div>
                      </div>
                      <span>{plan.Title}</span>
                    </div>
                  
                      <div>
                        <Link to={`/membership/${plan.Title}`} className="apllayBtn">Apply now</Link>
                      </div>
                    
                  </div>
                  <div
                    className="memberShipDescription"
                    style={{color:"#000"}}
                    dangerouslySetInnerHTML={{ __html: plan.description }}
                  />
                </Card>
              </Col>
            ))}
          </Row> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MemberShip;
